module.exports = __webpack_public_path__ + "img/high-resolution-grey.52081569.svg";